import dateAndTime from "date-and-time";
import SharedPreferences from "./SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";

export function formatDate(
  date: Date,
  formatText: string = "DD MMM YYYY hh:mm A"
) {
  return dateAndTime.format(new Date(date), formatText);
}

export function capitalizeFirstLetters(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

export function titleCaseWord(word: string) {
  if (!word) return word;
  return word[0].toUpperCase() + word.substr(1).toLowerCase();
}

export function hasEnglishLetters(word: string): boolean {
  return /[a-zA-Z]/.test(word);
}

export function getDominantColorOfImage(
  src: string
): Promise<Uint8ClampedArray> {
  return new Promise((resolve) => {
    let context = document.createElement("canvas").getContext("2d");
    context!.imageSmoothingEnabled = true;

    let img = new Image();
    img.src = src;
    img.crossOrigin = "";

    img.onload = () => {
      context!.drawImage(img, 0, 0, 1, 1);
      resolve(context!.getImageData(0, 0, 1, 1).data.slice(0, 3));
    };
  });
}

export function showPhoneNumberInAstericks(phoneNumber: string): string {
  const num =
    "+" +
    phoneNumber.substring(0, 4) +
    phoneNumber.substring(4, phoneNumber.length).replace(/[0-9]/g, "*");
  return num;
}

export function showGlobalLoadingView(show: boolean) {
  SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_LOADING, show);
}

export function truncateStringWithExtension(
  str: string,
  maxLength: number
): string {
  try {
    if (str.length > maxLength) {
      return (
        str.substring(0, maxLength - 3) +
        "... ." +
        str.split(".")[str.split(".").length - 1]
      );
    } else {
      return str;
    }
  } catch (e) {
    return "";
  }
}

export function openLink(link: string, target: "_self" | "_blank" = "_self") {
  window.open(link, target, "noopener,noreferrer");
}

export function downloadBlob(blob: Blob, filename = `report_${Date.now()}.pdf`) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}